export default {
  PROFILE: 'PROFILE',
  HISTORY: 'HISTORY',
  URL: 'URL',
  PHOTO: 'PHOTO',
  RESEARCH: 'RESEARCH',
}
